import React from "react";
import classnames from "classnames";
import { YearInReviewButton } from "@ugitgud/legos/ui/form/button/YearInReviewButton";
import { SvgYearInReviewLogoFull } from "@ugitgud/legos/ui/icon/SVG/year-in-review/YearInReviewLogoFull";
import { useLoginState } from "@ugg/shared/hooks/use-user-hooks";
import { useUserState } from "@ugg/shared/api/requests/accounts/user-state";
import { AppRoutes } from "@ugg/shared/routes/app-routes";

interface ProfileCTAProps {
  className?: string;
  utmSource: string;
  onClick?: (url: string) => void;
}

export default function ProfileCTA(props: ProfileCTAProps) {
  const { className, utmSource, onClick } = props;
  const classNames = classnames(className);

  const href = utmSource ? `${AppRoutes.YEAR_IN_REVIEW}?utm_source=${utmSource}` : AppRoutes.YEAR_IN_REVIEW;
  const onUrlClick = (e: React.MouseEvent) => {
    if (onClick) {
      e.preventDefault();
      onClick(href);
    }
  };

  return (
    <div className={classNames}>
      <div className="year-in-review-cta">
        <div className="w-full h-[208px] flex relative overflow-hidden border border-[#F4C874] rounded">
          <div className="relative h-[208px] w-full shrink-0 bg-no-repeat [background-image:linear-gradient(242deg,rgba(7,7,32,0)_-6.14%,#070720_100%),url('https://static.bigbrain.gg/assets/ugg/cta/year-in-review-karma-full.jpg')] bg-[position:60%_10%] [background-size:185%_auto]" />
          <div className="absolute inset-0 z-10 flex flex-col justify-start px-[18px] py-5 text-white">
            <SvgYearInReviewLogoFull className="w-[72px] h-[72px]" />
            <div className="relative -top-0.5 uppercase font-barlow font-semibold text-[18px] leading-[18px] text-center xs:text-left whitespace-nowrap mt-3 mb-[2px]">
              <span className="hidden xxs:inline">YEAR IN REVIEW</span>
            </div>
            <div className="font-inter font-medium text-[12px] leading-[12px] hidden xs:block text-center sm:text-left text-[#CDDCFE] mb-[17px]">
              A personally curated summary of your 2025 stats
            </div>
            <YearInReviewButton
              href={href}
              onClick={onUrlClick}
              className=" h-[30px] w-full px-[12px] py-[10px] space-x-2 sm:space-x-3 flex items-center flex-shrink"
            >
              <div className="text-[12px] sm:text-[13px] font-bold whitespace-nowrap">Generate Yours Now</div>
            </YearInReviewButton>
          </div>
        </div>
      </div>
    </div>
  );
}
